import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface DataTableTitleProps {
  children: ReactNode;
  /** Heading level that fits the surrounding page outline. */
  as?: "h2" | "h3" | "h4";
  icon?: LucideIcon;
  count?: number;
  description?: ReactNode;
}

/** Title block for the `title` slot of `DataTable` (heading + count + hint). */
export function DataTableTitle({
  children,
  as: Heading = "h3",
  icon: Icon,
  count,
  description,
}: DataTableTitleProps) {
  return (
    <div className="min-w-0">
      <Heading className="flex items-center gap-2 text-[15px] font-semibold tracking-tight text-surface-900">
        {Icon ? (
          <Icon className="h-4 w-4 shrink-0 text-surface-500" aria-hidden />
        ) : null}
        <span className="min-w-0">{children}</span>
        {count !== undefined ? (
          <span className="rounded-md bg-surface-100 px-1.5 py-0.5 text-xs font-medium tabular-nums text-surface-600">
            {count}
          </span>
        ) : null}
      </Heading>
      {description ? (
        <p className="mt-0.5 text-[13px] text-surface-500">{description}</p>
      ) : null}
    </div>
  );
}
